<div class="container">
  <div id="chart">
    <apx-chart
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [dataLabels]="chartOptions.dataLabels"
      [plotOptions]="chartOptions.plotOptions"
      [xaxis]="chartOptions.xaxis"
      [stroke]="chartOptions.stroke"
      [fill]="chartOptions.fill"
      [title]="chartOptions.title"
      [tooltip]="chartOptions.tooltip"
      [legend]="chartOptions.legend"
    ></apx-chart>
  </div>
</div>
